import React from "react";
import { Table } from "../../../../designSystem/Table";
import { Chip } from "../../../../designSystem/Chip";
import { BaseSegmentListViewProps } from "./SegmentListView";
import { OnOff } from "../../../../designSystem/inputs/OnOff";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";

export function SegmentListTableView (props: BaseSegmentListViewProps): JSX.Element
{
    if (!props.segmentLists)
        return <></>;

    function handleToggleClick (identifier: string, selected: boolean)
    {
        if (props.onToggleSelect)
            props.onToggleSelect(identifier, selected);
    }

    return (
        <>
            <Table style={{ overflowX: 'auto' }}>
                <thead>
                    <tr>
                        <th style={{ width: '40px' }}>
                            {props.onToggleSelect && props.onToggleAll &&
                                <OnOff size="small" active={props.segmentLists.every(s => s.selected)} onClick={props.onToggleAll} />
                            }
                        </th>
                        <th>Segmenter</th>
                        {props.displayAnswerCount &&
                            <th>Antal besvarelser</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {props.segmentLists.map(sl =>
                        <tr key={sl.identifier}>
                            <td>
                                {props.onToggleSelect &&
                                    <SegmentToggleCell identifier={sl.identifier} selected={sl.selected} onToggleClick={handleToggleClick} />
                                }
                            </td>
                            <td>
                                <Flex gap={4} style={{ flexWrap: 'wrap' }}>
                                    {sl.segments.map((s, index) =>
                                        <Chip key={sl.identifier + '-' + index} selected={sl.selected}>
                                            {s.value}
                                        </Chip>
                                    )}

                                </Flex>

                            </td>
                            {props.displayAnswerCount &&
                                <td>{sl.answerCount}</td>
                            }
                        </tr>
                    )}
                </tbody>
            </Table >
        </>
    );
}

function SegmentToggleCell (props: { identifier: string, selected: boolean, onToggleClick?:(identifier:string, selected:boolean)=>void }): JSX.Element
{
    function handleClick ()
    {
        if (props.onToggleClick)
            props.onToggleClick(props.identifier, !props.selected);
    }

    return (
        <>
            {props.onToggleClick &&
                <OnOff size="small" active={props.selected} onClick={handleClick} />
            }
        </>
    );
}